import { ConstrainedListSearchFilterDTO, ConstrainedListSearchFilterId, SearchFilterDTO } from "../..";

const constrainedListSearchTypes: Record<ConstrainedListSearchFilterId, true> = {
  "adopted-constraints-id": true,
  "company-status-id": true,
  "emerging-constraints-id": true,
  "flum-id": true,
  "planning-status-id": true,
  "ownership-type-id": true,
  "site-allocations-id": true,
  "site-allocations-emerging-id": true,
  "land-availability-assessment-id": true,
  "zone-type-id": true,
  "property-type-id": true,
  "tenure-uk": true,
  "agricultural-land-classification-id": true,
  "additional-opportunities-id": true,
  "property-state-id": true,
  "regeneration-zones-adopted-id": true,
  "regeneration-zones-emerging-id": true,
  "us-wetlands-id": true,
  "grey-belt-type-id": true,
  "traffic-count-type-id": true,
  "adopted-roads-type-id": true,
};

export function isConstrainedListSearchDTO(filter: SearchFilterDTO): filter is ConstrainedListSearchFilterDTO {
  return filter.id in constrainedListSearchTypes;
}
